(function() {
    'use strict';

    angular.module('plate', [
            'ui.router',
            'plate.constants',
            'plate.services'
        ])
        .config(uiRouting);

    uiRouting.$inject = ['$stateProvider', 'userPermissionsConst', 'platePermissionsConst'];

    function uiRouting($stateProvider, userPermissionsConst, platePermissionsConst) {
        $stateProvider
            .state('layout.plate', {
                abstract: true,
                url: '/plates',
                data: {
                    title: 'Płyty',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.plate.list', {
                url: '/list',
                views: {
                    'main@layout': {
                        templateUrl: 'app/plate/views/plate-list/plate-list.html',
                        controller: 'PlateListController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: platePermissionsConst.view
                }
            })
            .state('layout.plate.create', {
                url: '/create',
                views: {
                    'main@layout': {
                        templateUrl: 'app/plate/views/plate-create/plate-create.html',
                        controller: 'PlateCreateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: platePermissionsConst.add
                }
            })
            .state('layout.plate.update', {
                url: '/update/:pk',
                views: {
                    'main@layout': {
                        templateUrl: 'app/plate/views/plate-update/plate-update.html',
                        controller: 'PlateUpdateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: platePermissionsConst.update
                }
            });
    }
})();
